import { colors } from '@globals/themes/defaultTheme'
import { normalFontWeight } from '@globals/themes/themeConstants'
import Chip from '@mui/material/Chip'
import { T } from '@transifex/react'

type NewSpaceChip = {
  size?: 'small' | 'medium'
}
const NewSpaceChip: React.FC<NewSpaceChip> = ({ size }) => {
  return (
    <Chip
      sx={{
        minHeight: 24,
        height: 30,
        '&&& .MuiChip-label': {
          color: `${colors.greenDark} !important`,
          fontWeight: normalFontWeight,
        },
      }}
      variant="success"
      size={size || 'medium'}
      label={<T _str="NEW" />}
    />
  )
}

export default NewSpaceChip
